export const backGroundImage = (setDisplayImages) => {
  // 24枚の画像を slides 配列に追加
  const slides = Array.from({ length: 19 }, (_, index) => ({
    src: `/images/img${index + 1}.jpg`,
    alt: `Slide ${index + 1}`,
  }));

  // ランダムに画像を選択する関数
  const getRandomImages = () => {
    const shuffledSlides = [...slides].sort(() => 0.5 - Math.random());
    return shuffledSlides.slice(0, 1);
  };

  const updateImages = () => {
    setDisplayImages(getRandomImages());
  };

  updateImages(); // 初回の画像選択
  // const interval = setInterval(updateImages, 300000); // 8秒ごとに画像を更新
  // return () => clearInterval(interval);
};
